var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leader",
    transform: "translate(-816 -789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leader-2",
    "data-name": "leader",
    transform: "translate(816 792.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M15.27,24.22a4.879,4.879,0,0,1-4.949,4.806,4.808,4.808,0,1,1,0-9.611A4.879,4.879,0,0,1,15.27,24.22m35.352,0a4.951,4.951,0,1,0-4.949,4.806,4.879,4.879,0,0,0,4.949-4.806",
    transform: "translate(2.003 7.972)",
    fill: "#ffa726"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M8.371,18.831c0-15.526,37.013-10.109,37.013,0v12.2c.131,9.985-8.154,18.182-18.507,18.31-10.351-.127-18.635-8.322-18.507-18.3Z",
    transform: "translate(3.122 4.581)",
    fill: "#ffb74d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M48.736,21.356c-.592-7.289-3.447-15.389-12.61-17.2L34.71,1.414H27.626c-11.539,0-21.253,9.129-21.253,21.968v4.152l4.251,4.086V24.755l25.5-8.238,8.5,6.865V31.62l4.251-4.086V23.382a16.146,16.146,0,0,0-.142-2.027",
    transform: "translate(2.377 0.527)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M20.2,24.161a3.433,3.433,0,0,0-6.728,0Z",
    transform: "translate(5.493 8.682)",
    fill: "#784719"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M31.2,24.161a3.433,3.433,0,0,0-6.728,0Z",
    transform: "translate(9.978 8.682)",
    fill: "#784719"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M23.236,37.279A6.865,6.865,0,0,0,30.1,30.414H16.371a6.865,6.865,0,0,0,6.865,6.865Z",
    transform: "translate(6.764 12.526)",
    fill: "#c62828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M29.522,33.16a6.836,6.836,0,0,0,.579-2.746H16.371a6.836,6.836,0,0,0,.579,2.746Z",
    transform: "translate(6.764 12.332)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M35.605,5.658,33.664,3.717,37.381,0l1.941,1.941ZM46.128,8.709,45.109,6.158,38.244,8.9l1.019,2.551Zm-.509,6.963H40.127v2.746h5.492Z",
    transform: "translate(13.872)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M6.806,1.941,8.747,0l3.717,3.717L10.523,5.658Zm.059,9.514L7.884,8.9,1.019,6.158,0,8.709ZM.509,18.417H6V15.671H.509Z",
    fill: "#ffc107"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 60,
    height: 60,
    transform: "translate(816 789)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeader);
export default __webpack_public_path__ + "static/media/leader.53499dd1529303726b584831c8d2e806.svg";
export { ForwardRef as ReactComponent };